import { useEffect, useState } from 'react';

import { IS_DRAGGING_CLASS } from '@shared/model/globals';

/**
 * React-хук, который определяет, происходит ли сейчас drag на странице.
 *
 * Наблюдает за корневым элементом документа (`document.documentElement`) и
 * возвращает `true`, пока на нём есть указанный CSS-класс.
 *
 * @param className - CSS-класс, который помечает состояние перетаскивания.
 * @returns `true`, если класс присутствует на корневом элементе, иначе `false`.
 */
export const useIsDragging = (className = IS_DRAGGING_CLASS) => {
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        const el = document.documentElement;

        const update = () => setIsDragging(el.classList.contains(className));
        update();

        const mo = new MutationObserver(update);
        mo.observe(el, { attributes: true, attributeFilter: ['class'] });

        return () => mo.disconnect();
    }, [className]);

    return isDragging;
};
